import React, { FC, useState } from 'react'
import GuestLayout from '../../components/layouts/guest_layout'
import useFaq from './hooks/use_faq'
import FaqBlock from './components/faq_block'
import LoadingSpinner from '../../components/loading/loading_spinner'

const FaqPage: FC = () => {
  const [faq, loading] = useFaq()
  const [selectedCategory, setSelectedCategory] = useState<string>('')

  const scrollToCategory = (categoryId: string) => {
    setSelectedCategory(categoryId)
    const element = document.getElementById(categoryId)
    if (element) {
      const offset = 100
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }
  }

  const getCategoryId = (category: string) => {
    return `category-${category.replace(/\s+/g, '-')}`
  }

  const faqBlocks = (
    <div className="w-full py-12 px-0 sm:px-8 max-w-5xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-main-green">よくある質問</h1>
      </div>

      {/* カテゴリーボタン */}
      <div className="mb-8 flex flex-wrap justify-center gap-3">
        {faq.map((item) => {
          const categoryId = getCategoryId(item.category)
          return (
            <button
              key={categoryId}
              className={`px-4 py-2 rounded border transition-colors whitespace-nowrap ${
                selectedCategory === categoryId
                  ? 'bg-main-green text-white border-main-green'
                  : 'bg-white text-main-black border-main-darkgray hover:border-main-green'
              }`}
              onClick={() => scrollToCategory(categoryId)}
            >
              {item.category}
            </button>
          )
        })}
      </div>

      {loading ? (
        <LoadingSpinner className="mx-auto" />
      ) : (
        <>
          {faq.map((item, index) => {
            return (
              <div
                key={`faq-${String(index)}`}
                id={getCategoryId(item.category)}
              >
                <FaqBlock category={item.category} faqs={item.faqs} />
              </div>
            )
          })}
          {faq.length === 0 && (
            <div className="text-center py-8">
              <p className="text-main-darkgray">FAQがありません</p>
            </div>
          )}
        </>
      )}
    </div>
  )

  return (
    <GuestLayout>
      <div className="container mx-auto px-4 py-8">{faqBlocks}</div>
    </GuestLayout>
  )
}

export default FaqPage
